import React from 'react';
import { useAuthCallback } from '../lib/auth';

const AuthCallback = () => {
  const status = useAuthCallback();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-orange-50">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 border-4 border-[hsl(207,90%,54%)] border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-700 font-medium">
          {status === 'error' ? 'Erreur de connexion...' : 'Connexion en cours...'}
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
